import { render, staticRenderFns } from "./Resumen.vue?vue&type=template&id=e847598c"
import script from "./Resumen.vue?vue&type=script&lang=js"
export * from "./Resumen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/plantitas/Resumen.vue
// module id = null
// module chunks = 